import dayjs from "./dayjs";
import { ColumnIds, DateModes } from "./types";

const DateUtil = {
  getDatesRangeInDays: function(dateStart: any, dateEnd: any) {
    return Math.abs(dayjs.utc(dateStart).diff(dateEnd, "days")) + 1;
  },
  isDatesRangeMoreThan3Months: function (dateStart: any, dateEnd: any) {
    return Math.abs(dayjs.utc(dateStart).diff(dateEnd, "months")) > 3 || Math.abs(dayjs.utc(dateStart).diff(dateEnd, "days")) > 92;
  }
};

export function calculateISO8601WeekBoundaries(iso8601Week:string, iso8601Month?:string): [dayjs.Dayjs, dayjs.Dayjs] {
    // assuming a string like "2020-W01" and extract 2020, 01
    const [year, week] = iso8601Week.split("-W");
    let weekStart = dayjs().utc().year(parseInt(year)).isoWeek(parseInt(week)).startOf("isoWeek").startOf("day");
    let weekEnd = weekStart.endOf("isoWeek").startOf("day");

    if ( iso8601Month === null || iso8601Month.length === 0 ) {
      return [weekStart, weekEnd];
    }

    const [monthYear, monthMonth] = iso8601Month.split("-");
    const monthStart = dayjs.utc().year(parseInt(monthYear)).month(parseInt(monthMonth)-1).startOf("month").startOf("day");
    const monthEnd = monthStart.endOf("month").startOf("day");

    if ( weekStart.isBefore(monthStart) ) {
      weekStart = monthStart;
    } else if ( weekEnd.isAfter(monthEnd) ) {
      weekEnd = monthEnd;
    }

    return [weekStart, weekEnd];
}

export function determineStartingDateMode(groupBys: string[], dateStart: dayjs.Dayjs, dateEnd: dayjs.Dayjs): DateModes {
  const datesMonthBounded = dateStart.isSame(dateStart.startOf("month"), "day")
                    && dateEnd.isSame(dateEnd.endOf("month"), "day");
  const datesWeekBounded = dateStart.isSame(dateStart.startOf("isoWeek"), "day")
                    && dateEnd.isSame(dateEnd.endOf("isoWeek"), "day");

  const hasWeekGroupBy = groupBys.includes(ColumnIds.week);
  const hasDateGroupBy = groupBys.includes(ColumnIds.date);    
  const hasMonthGroupBy = groupBys.includes(ColumnIds.month);

  // weeks with a week group-by and nothing else
  if ( datesWeekBounded && hasWeekGroupBy && !hasMonthGroupBy && !hasDateGroupBy ) {
    return "weeks";

  // months with either month group-by or no period group-by
  } else if ( datesMonthBounded && !hasWeekGroupBy && !hasDateGroupBy ) {
    return "months";

  // everything else is days
  } else {
    return "days";
  }
}

/**
 * Checks for expected date string formats like:
 * 
 *    2023-05-01, 2023-05, 2023-W01 (ISO8601 week)
 * 
 * Leading/trailing spaces will be accepted. Because dayjs parses them as accepted.
 * 
 * Is only looking for exact date string formats that will be returned from the APIs.
 */
export function isValidDateString(dateString:string):boolean {
  // handle 2023-05-01, 2023-05, 2023-W01 (ISO8601 week )
  return !!dateString?.match(/^ *([0-9]{4})-W?([0-9]{1,2})(-[0-9]{2})? *$/);
}

export default DateUtil;